module.exports = "<div class=\"sub-nav\">\r\n  <ul class=\"nav justify-content-center\">\r\n    <li class=\"nav-item mx-2 mx-md-4\" *ngFor=\"let navItem of subnav.navItems\">\r\n      <!--<a class=\"nav-link small\" [routerLink]=\"['/' + subnav.routing,navItem.id]\">{{navItem.navItem}}</a>-->\r\n      <a class=\"nav-link small\" [routerLink]=\"[navItem.id]\">{{navItem.navItem}}</a>\r\n    </li>\r\n  </ul>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/education-and-career/subnav/subnav.component.html
// module id = ../../../../../src/app/components/education-and-career/subnav/subnav.component.html
// module chunks = main